// extracted by mini-css-extract-plugin
export default {"bulletWrapper":"About_bulletWrapper__iF13o"};